module.exports = __webpack_public_path__ + "static/media/laundries.52f449fb.png";